module.exports = {
    digitalPayScreenReaderMessages: {
        accountPasswordDisableStateMessage: 'Account password is blank or invalid.',
        creditCardAddDisableMessage: 'Credit Card is blank or invalid.',
        creditCardCvvDisableMessage: 'Credit Card X-{0} CVV is blank or invalid.',
        creditCardManageModeDisableMessage: 'You are in credit card manage mode. Close it to enable placing orders.',
        giftCardAddDisableMessage: 'Gift Card is invalid or blank.',
        giftCardManageModeDisableMessage: 'You are in gift card manage mode. Close it to enable placing orders.',
        giftCardAmountDisableMessage: 'Gift Card X-{0} amount is incomplete.',
        placeOrderInvalidDisableMessage: 'Unable to place order. Reasons: {0}',
        placeOrderProcessingDisableMessage: 'Currently placing order, please wait.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/digitalpay-screenreader-messages.js